export default __webpack_public_path__ + "static/media/15.bff760b8.gif";